import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import { trans } from '../../utils';
import { joinDiscussionPresence, presenceEnabled } from '../../utils/presence';
/**
 * "{count} lendo agora" na meta do hero. Entra no presence channel ao montar e
 * sai ao desmontar; a navegação entre discussões reusa a instância, então o
 * onupdate reentra quando o id muda. Com menos de 2 leitores não desenha nada.
 */
export default class WhoIsReading extends Component {
  constructor(...args) {
    super(...args);
    // Não usar `state`: é reservado pelo Component do Mithril (2º generic).
    _defineProperty(this, "presence", {
      members: [],
      count: 0
    });
    _defineProperty(this, "leave", null);
    _defineProperty(this, "joinedId", '');
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.join();
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    const id = String(this.attrs.discussion?.id?.() || '');
    if (id && id !== this.joinedId) this.join();
  }
  onremove() {
    this.leave?.();
    this.leave = null;
  }
  view() {
    if (!presenceEnabled() || this.presence.count < 2) return null;
    const shown = this.presence.members.slice(0, 6);
    return m("span", {
      className: "DiscussionHero-metaItem AvocadoPresence"
    }, m("span", {
      className: "AvocadoPresence-dot",
      "aria-hidden": "true"
    }), m("span", {
      className: "AvocadoPresence-avatars",
      "aria-hidden": "true"
    }, shown.map(member => member.avatarUrl ? m("img", {
      key: member.id,
      className: "AvocadoPresence-avatar",
      src: member.avatarUrl,
      alt: "",
      title: member.displayName
    }) : m("span", {
      key: member.id,
      className: "AvocadoPresence-avatar AvocadoPresence-avatar--initial",
      title: member.displayName
    }, member.displayName.charAt(0).toUpperCase()))), trans('ramon-avocado.forum.presence.reading_now', '{count} reading now', {
      count: this.presence.count
    }));
  }
  join() {
    this.leave?.();
    const id = String(this.attrs.discussion?.id?.() || '');
    this.joinedId = id;
    this.presence = {
      members: [],
      count: 0
    };
    if (!id) return;
    this.leave = joinDiscussionPresence(id, next => {
      this.presence = next;
      m.redraw();
    });
  }
}
flarum.reg.add('ramon-avocado', 'forum/components/shared/WhoIsReading', WhoIsReading);